import React, { useState, useEffect } from 'react';
import {
  PageHeader,
  Card,
  Typography,
  Tag,
  Button,
  Modal,
  Divider,
  Drawer,
  Input,
  Popover,
  notification,
} from 'antd';
import { LikeOutlined, CommentOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { AiFillLike, AiOutlineLike } from 'react-icons/ai';
import './../../styles/components/MarketPlace/JobListings.scss';
import { useHistory } from 'react-router-dom';
import ClientJobHeader from './ClientJobHeader';
import ApplyJobModal from './ApplyJobModal';
import {
  APPLICABLE_JOBS,
  companyWiseMaxSalary,
  jobTypes,
} from '../../constants/MarketplaceConstants';
import {
  formatPlaystoreNumbers,
  numberWithCommas,
  playstoreNumberSuffix,
} from '../../utils/MarketplaceUtils';
import { Navigation } from '../../services/NavigationService';
import { Routes } from '../../constants/RouterConstants';
import ReactPlayer from 'react-player/youtube';
import JobLocalitiesDrawer from './JobLocalitiesDrawer';
import CommentSection from './CommentSection';
import {
  fetchLocalities,
  getUserDetailsById,
  getJobComments,
  getJobLikesByClient,
  addJobLikeByClient,
  removeJobLikeByClient,
  checkJobLikedByJobseeker,
} from '../../services/API/MarketplaceService';
import useMoengage from '../../hooks/useMoengage';
import { useMitraDispatch, useMitraStore } from '../../contexts/MitraContext';
import moment from 'moment';
import DuplicateApplicationPopup from './popups/DuplicateApplicationPopup';
import { useTranslation } from 'react-i18next';
import { ratingsData } from '../../constants/MarketplaceConstants';
import ReusableReviewComponent from './ReusableReviewComponent';
import { jobListingPageTestimonials } from '../../constants/MarketplaceConstants';
import jd_testimonial from '../../assets/jd_testimonial.svg';

const { Text } = Typography;
const { Search } = Input;

const JobCard = ({ showCTA = true, jobData, city, jobType, jobIndex }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showApplyJobModal, setShowApplyJobModal] = useState(false);
  const [openLocalitiesDrawer, setOpenLocalitiesDrawer] = useState(false);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const history = useHistory();
  const applicableJobs = APPLICABLE_JOBS;
  const userId = localStorage.getItem('userId');

  const [userLocationPreference, setUserLocationPreference] = useState('');
  const [localities, setLocalities] = useState([]);
  const [filteredLocalities, setFilteredLocalities] = useState(localities);
  const [jobDescription, setJobDescription] = useState({});
  const [commentsCount, setCommentsCount] = useState(0);
  const [likesCount, setLikesCount] = useState(0);
  const [likedJob, setLikedJob] = useState(false);
  const [, trackEvent] = useMoengage();
  const { selectedMitraDetails } = useMitraStore();
  const [showDuplicateApplicationPopup, setShowDuplicateApplicationPopup] = useState(false);

  const { actions: MitraActions } = useMitraDispatch();
  const { setSelectedJobDescription } = MitraActions;
  const { t } = useTranslation();
  const companyData = ratingsData[jobData.companyName.toLowerCase()];

  const fetchJobLocalities = location => {
    const payload = {
      city: location,
      client: jobData.companyName,
    };

    fetchLocalities(payload)
      .then(response => {
        setLocalities([...response.data.jobLocations]);
        setFilteredLocalities([...response.data.jobLocations]);
      })
      .catch(error => console.log(error));
  };

  // useEffect(() => {
  //   testInd += 1;
  // }, [inputInd]);

  useEffect(() => {
    if (localStorage.getItem('preferredLocation')) {
      setUserLocationPreference(localStorage.getItem('preferredLocation'));
      fetchJobLocalities(localStorage.getItem('preferredLocation'));
    } else {
      getUserDetailsById(localStorage.getItem('userId'))
        .then(response => {
          setUserLocationPreference(response.data.jobseekerCityPreference);
          fetchJobLocalities(response.data.jobseekerCityPreference);
        })
        .catch(error => console.log(error));
    }
  }, []);

  const getCommentsCount = companyName => {
    getJobComments(companyName)
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        }
      })
      .then(responseObj => {
        const count = Array.isArray(responseObj?.data) ? responseObj?.data.length : 0;
        setCommentsCount(count);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const getLikesCount = companyName => {
    getJobLikesByClient(companyName)
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        }
      })
      .then(responseObj => {
        setLikesCount(responseObj?.data?.count ? responseObj?.data?.count : 0);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const isJobLiked = companyName => {
    checkJobLikedByJobseeker({ userId, companyName })
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        } else throw response?.data?.error;
      })
      .then(responseObj => {
        setLikedJob(responseObj?.data?.isLiked);
      })
      .catch(error => {
        console.log(error);
        setLikedJob(false);
      });
  };

  const addJobLike = () => {
    const cityName = userLocationPreference;
    const companyName = jobData?.companyName;
    addJobLikeByClient({ userId, companyName, cityName })
      .then(response => {
        getLikesCount(companyName);
        isJobLiked(companyName);
      })
      .catch(error => {
        notification.error({
          message: 'Something went wrong, Please try again !',
        });
        console.log(error);
      });
  };

  const removeJobLike = () => {
    const cityName = userLocationPreference;
    const companyName = jobData?.companyName;
    removeJobLikeByClient({ userId, companyName, cityName })
      .then(response => {
        getLikesCount(companyName);
        isJobLiked(companyName);
      })
      .catch(error => {
        notification.error({
          message: 'Something went wrong, Please try again !',
        });
        console.log(error);
      });
  };

  useEffect(() => {
    const companyName = jobData?.companyName;
    setJobDescription(jobData?.jobDetails);
    getCommentsCount(companyName);
    getLikesCount(companyName);
    isJobLiked(companyName);
  }, [jobData]);

  const showModal = () => {
    setSelectedJobDescription(jobData.jobDetails);
    if (jobType === jobTypes.COMING_SOON || jobType === jobTypes.UNAVAILABLE) {
      setShowDuplicateApplicationPopup(true);
    } else {
      trackEvent('jse_clicked_apply_now_on_job_card', {
        userId: localStorage.getItem('userId'),
        jobId: jobData.id,
        companyName: jobData.companyName,
        userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
        timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
      });

      localStorage.setItem('jobData', JSON.stringify([jobData]));
      const route = {
        pathname: Routes.JOB_DESCRIPTION,
        search: `city=${city}&client=${jobData.companyName}`,
      };
      Navigation.push(route);
    }
  };

  const viewApplicationStatus = () => {
    setSelectedJobDescription(jobData.jobDetails);
    const route = {
      pathname: Routes.APPLICATION_STATUS,
      search: `applicationId=${jobData.scheduledInterviewId}&city=${localStorage.getItem(
        'preferredLocation'
      )}`,
    };
    Navigation.push(route);
    // history.replace(`/application-status?applicationId=${jobData.scheduledInterviewId}`);
  };

  const showDrawer = () => {
    trackEvent('jse_clicked_check_job_areas', {
      userId: localStorage.getItem('userId'),
      jobId: jobData.id,
      companyName: jobData.companyName,
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
    });
    setOpenLocalitiesDrawer(true);
  };

  const onClose = () => {
    setOpenLocalitiesDrawer(false);
  };

  const onSearchLocality = value => {
    trackEvent('jse_job_area_searched', {
      userId: localStorage.getItem('userId'),
      jobId: jobData.id,
      companyName: jobData.companyName,
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
    });
    if (value === '') {
      setFilteredLocalities(localities);
    } else {
      let filteredItems = localities.filter(locality =>
        locality.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredLocalities([...filteredItems]);
    }
  };

  const cardStyle = {
    margin: '0px 24px 24px 24px',
    borderRadius: jobData.videoUrl ? '0 0 8px 8px' : '8px 8px',
    background: '#EFEFEF',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
    borderRight: '1px solid rgba(0, 0, 0, 0.06)',
    borderTop: jobData.videoUrl ? 'none' : '1px solid rgba(0, 0, 0, 0.06)',
    opacity: jobType === jobTypes.UNAVAILABLE ? '0.6' : '1',
  };

  return (
    <>
      <DuplicateApplicationPopup
        open={showDuplicateApplicationPopup}
        close={() => setShowDuplicateApplicationPopup(false)}
        jobType={jobType}
        accessOrigin={'JobCard'}
        company={jobData.displayName ? jobData.displayName?.charAt(0).toUpperCase() + jobData.displayName?.slice(1): 
          jobData.clientName?.charAt(0).toUpperCase() + jobData.clientName?.slice(1)}
      />

      <JobLocalitiesDrawer
        jobData={jobData}
        openDrawer={openLocalitiesDrawer}
        onClose={onClose}
        localities={filteredLocalities}
        onSearchLocality={onSearchLocality}
      />

      <div className="single-job-card-main-container">
        <div
          className="video-section-marketplace"
          style={jobType === jobTypes.UNAVAILABLE ? { opacity: '0.6' } : { opacity: 1 }}
        >
          {jobData.videoUrl && (
            <img
              src="/images/new-job-indicator.png"
              style={{ width: '94px', position: 'absolute', top: '15px', left: '-3px' }}
            ></img>
          )}
          <ReactPlayer height="auto" width="auto" url={jobData.videoUrl} controls />
        </div>

        <Card
          style={cardStyle}
          bodyStyle={{ padding: '8px', display: 'flex', flexDirection: 'column', gap: '1em' }}
        >
          <ClientJobHeader jobData={jobData} />

          {companyData?.rating > 0 && (
            <div className="play-store-ratings">
              <img src="/images/play-icon.png"></img>
              <div className="star-ratings-container">
                {Array.apply(null, { length: companyData?.rating / 1 }).map((item, index) => (
                  <img key={index} src="/images/full-star.png"></img>
                ))}
                {companyData?.rating % 1 > 0 && <img src="/images/half-star.png"></img>}
              </div>

              <Text className="ratings-text">
                Rated {companyData?.rating} by {companyData?.ratingCnt} Users
              </Text>

              {
                <Popover
                  trigger="hover"
                  overlayStyle={{ width: '300px' }}
                  content={`This is the playstore rating of ${jobData.companyName} app on Google Playstore`}
                >
                  <InfoCircleOutlined style={{ color: '#D34B18' }} />
                </Popover>
              }
            </div>
          )}

          <div style={{ border: '1px solid #DFDDDD', margin: '0 12px' }}></div>

          <div className="job-summary">
            <Text className="compensation">
              {t('earn_upto_part1')} ₹{jobData.baseSalary} {t('earn_upto_part2')}
            </Text>

            {jobDescription.cardInfo ? (
              <Text className="work-hours">
                {/* <ClockCircleFilled /> */}
                {/* <span style={{fontSize:'1.2em', fontWeight:'700'}}>Vehicle type: {jobData.vertical}</span> */}
                <img src="/images/money.png" />
                <span style={{ fontSize: '1.2em', fontWeight: '700' }}>
                  {jobDescription.cardInfo}
                </span>
              </Text>
            ) : null}

            {jobType ? null : (
              <Text className="availability">
                <div className="vacancy-section">
                  <img src="/images/scooter.png" style={{ width: 'auto', height: '15px' }} />
                  <span
                    style={{
                      fontSize: '0.85em',
                      color: '#111111',
                      fontWeight: '700',
                      display: 'flex',
                      whiteSpace: 'nowrap',
                      alignItems: 'center',
                    }}
                  >
                    <Text>
                      {Math.min(jobData?.numOpenings, 150) === 150 ? '150+' : jobData?.numOpenings}{' '}
                      Openings {userLocationPreference ? 'in' : ''}{' '}
                    </Text>
                    <Text style={{ color: '#D34B18', paddingLeft: '0.23em' }}>
                      {userLocationPreference ? `${userLocationPreference}` : ''}
                    </Text>
                  </span>
                </div>
                <a className="localities" onClick={() => showDrawer()}>
                  Check Job Areas
                </a>
              </Text>
            )}
          </div>

          {showCTA ? (
            <div className="job-action-cta">
              <Button className='view-details' onClick={()=>showModal()}>View Details</Button>

              {(!jobData.scheduledInterviewId || jobData.isUnavailable) ? (
                <Button
                  className="apply-now"
                  style={jobType ? { opacity: '0.6' } : { opacity: 1 }}
                  onClick={() => {
                    showModal();
                  }}
                >
                  Apply Now
                </Button>
              ) : null}

              {jobData.scheduledInterviewId && !jobData.isUnavailable ? (
                <Button className="apply-now" onClick={() => viewApplicationStatus()}>
                  Track Status
                </Button>
              ) : null}

              <ApplyJobModal
                open={showApplyJobModal}
                close={() => setShowApplyJobModal(false)}
                jobData={jobData}
              />
            </div>
          ) : null}

          <div style={{ border: '1px solid #FEFEFE', margin: '0 12px' }}></div>

          <div className="user-ratings-container">
            <div
              className="like-information"
              onClick={() => (likedJob ? removeJobLike() : addJobLike())}
            >
              {likedJob ? <AiFillLike /> : <AiOutlineLike />} {likesCount}{' '}
              {likesCount <= 1 ? 'Like' : 'Likes'}
            </div>
            <div className="seperator"></div>
            <div
              className="comments-information"
              onClick={() => {
                trackEvent('jse_clicked_comments', {
                  userId: localStorage.getItem('userId'),
                  jobId: jobData.id,
                  companyName: jobData.companyName,
                  userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
                  timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
                });
                setShowCommentSection(true);
              }}
            >
              <CommentOutlined /> {commentsCount} Comments
            </div>
          </div>
        </Card>
      </div>

      {jobIndex < jobListingPageTestimonials.allTestimonials.length ? (
        <div className="testimonial-section">
          <ReusableReviewComponent
            testimonialData={jobListingPageTestimonials.allTestimonials[jobIndex]}
            testimonialImage={jobListingPageTestimonials.allTestimonials[jobIndex].testimonialImg}
          />
        </div>
      ) : (
        null
      )}

      <CommentSection
        open={showCommentSection}
        close={() => setShowCommentSection(false)}
        jobData={jobData}
        getCommentsCount={getCommentsCount}
      />
    </>
  );
};
export default JobCard;
